import { createSelector } from "reselect"
import { find, get, chain } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { getFilteredData, getCategoryItems } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getCategoryItems, getSelectedDate],
  (data, items, date) => {
    const datum = find(data, item => item.date.isSame(date))

    return chain(items)
      .map(item => ({
        ...item,
        value: get(datum, item.id),
      }))
      .sortBy(({ value }) => -Math.abs(value))
      .value()
  },
)
